import { media, useMediaQuery } from '@utilitywarehouse/hearth-react';

const useBreakpoints = () => {
  const breakpointsUp = {
    sm: useMediaQuery(media.above('tablet')),
    md: useMediaQuery(media.above('desktop')),
    lg: useMediaQuery(media.above('wide')),
  };

  const breakpointsDown = {
    sm: useMediaQuery(media.below('tablet')),
    md: useMediaQuery(media.below('desktop')),
    lg: useMediaQuery(media.below('wide')),
  };

  return { breakpointsUp, breakpointsDown };
};

export { useBreakpoints };
